export default __webpack_public_path__ + "static/media/Frame1.355f46cb.png";